import { gql } from '@apollo/client'

import { ACTION_COMPLETE_FRAGMENT } from '../fragments/ActionCompleteFragment'
import { ACTION_NOTE_FRAGMENT } from '../fragments/ActionNoteFragment'

export const GET_ACTION_NOTES_AND_COMPLETIONS = gql`
  query GetActionNotesAndCompletions(
    $filters: ActionsInput!
    $pagination: OffsetLimitPaginationFilter
  ) {
    tenantActionNotesAndCompletions(
      filters: $filters
      pagination: $pagination
    ) {
      totalCount
      results {
        ... on ActionNote {
          ...ActionNote
        }
        ... on ActionComplete {
          ...ActionComplete
        }
      }
    }
  }
  ${ACTION_NOTE_FRAGMENT}
  ${ACTION_COMPLETE_FRAGMENT}
`
